import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CurrencyCard from '../components/CurrencyCard';
import CurrencyTool from '../components/CurrencyTool';
import HeroDashboardMockup from '../components/HeroDashboardMockup';
import MarketWidget from '../components/MarketWidget';
import PartnerShowcase from '../components/PartnerShowcase';
import { FaSyncAlt } from 'react-icons/fa';

const Home = () => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCurrencies();

    const interval = setInterval(() => {
      fetchCurrencies();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const fetchCurrencies = async () => {
    try {
      const { data } = await axios.get('/api/currency');
      setCurrencies(data);
      setLoading(false);
    } catch (error) {
      console.error('Döviz kurları yüklenemedi:', error);
      setLoading(false);
    }
  };

  return (
    <div className="font-sans min-w-0 overflow-x-clip">
      {/* Hero Section */}
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-[#120b4d] via-[#3b1ccf] to-[#7c2dff] rounded-2xl sm:rounded-3xl px-4 sm:px-6 lg:px-12 py-8 sm:py-10 lg:py-12 mb-6 sm:mb-8 shadow-xl lg:shadow-2xl relative overflow-hidden flex flex-col justify-center lg:min-h-[460px]">
        
        <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-5 sm:gap-8 w-full min-w-0">
          {/* Left Column: Text (43%) */}
          <div className="w-full min-w-0 lg:w-[43%] text-white text-center lg:text-left space-y-3 sm:space-y-4">
            <div className="flex justify-center lg:justify-start">
              <div className="inline-flex max-w-full items-center px-2.5 sm:px-3 py-1 rounded-full bg-white/10 border border-white/20 backdrop-blur-md hover:bg-white/20 transition-colors cursor-default">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-300 animate-pulse mr-2"></span>
                <span className="text-[10px] sm:text-xs font-medium text-amber-50 tracking-wide leading-tight">v0.9 Beta • Geliştirme Aşamasında</span>
              </div>
            </div>
            <h1 className="text-[1.75rem] leading-tight sm:text-3xl md:text-4xl font-extrabold tracking-tight">
              Fiziki Varlık Yönetim Platformu
            </h1>
            <p className="text-indigo-100 text-sm sm:text-base md:text-xl max-w-xl mx-auto lg:mx-0 font-light leading-relaxed">
              Döviz, altın ve emtia yatırımlarınızı tek bir modern arayüzden takip edin, analiz edin ve yönetin.
            </p>
            <div className="pt-1 sm:pt-2">
              <div className="inline-flex max-w-full items-center justify-center gap-2 text-[11px] sm:text-sm text-indigo-200 bg-white/10 px-3 sm:px-4 py-2 rounded-full border border-white/10">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>
                <span>Portföy verileriniz güvenli kullanıcı hesabınızda saklanır ve yalnızca sizin hesabınızla erişilebilir.</span>
              </div>
            </div>
          </div>

          {/* Right Column: Hero Dashboard Mockup (57%) */}
          <div className="w-full min-w-0 lg:w-[57%] flex items-center justify-center lg:justify-end">
            <HeroDashboardMockup />
          </div>
        </div>
      </div>

      <div className="lg:hidden mx-auto max-w-md px-3 sm:px-4 space-y-6 mb-8">
        <MarketWidget />
        <PartnerShowcase compact />
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 pb-12 min-w-0">

        {/* Döviz Çevirici */}
        <div className="mb-12">
          <CurrencyTool />
        </div>

        {/* Current Prices Header */}
        <div className="mb-8 bg-primary-50 dark:bg-slate-900 rounded-2xl p-4 sm:p-6 shadow-lg border border-primary-100 dark:border-white/10 transition-colors duration-300 ease-in-out">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3 flex items-center space-x-3">
            <span>Güncel Kurlar</span>
          </h2>
          <p className="text-sm sm:text-base text-gray-700 dark:text-gray-300 flex flex-wrap items-center gap-2">
            <FaSyncAlt className="animate-spin text-primary-600 dark:text-primary-400" />
            <span className="font-medium">Son güncelleme: {new Date().toLocaleString('tr-TR')}</span>
            <span className="text-green-600 dark:text-green-400 font-bold animate-pulse">● Canlı</span>
          </p>
        </div>

        {/* Currency Cards */}
        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-600"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12">
            {['USD', 'EUR', 'GRAM', 'CEYREK', 'TAM', 'XAU_CUM', 'XAGTRYG'].map(code => {
              const currency = currencies.find(c => c.code === code);
              if (!currency) return null;
              return <CurrencyCard key={currency.code} currency={currency} />;
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
